import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
// import MenuItem from 'material-ui/MenuItem'
// import { chunk } from 'lodash';

// import ColorPicker from '../colorPicker/ColorPicker';
import { renderCheckbox, renderTextField} from '../../utils/materialUiReduxForms';
// import { generateCssString } from './../../actions/clientproduct/update';
import { productSettings } from '../../constants';
import { /*Spinner,*/ RichSpinner } from './../loaders';
import { literals } from './../../languages';
import { getUserRoles } from '../../utils/helpers';



class Form extends Component {

  componentWillMount () {
    let token = localStorage.getItem('betwidgets_login_token');
    if (token) {
      let roles = getUserRoles(token);
      this.setState({
        'isAdmin': roles.indexOf('ROLE_ADMIN') !== -1  ? true : false
      });
    }
  }

  renderField(data) {
    const hasError = data.meta.touched && !!data.meta.error;
    if (hasError) {
      data.input['aria-describedby'] = `clientproduct_${data.input.name}_helpBlock`;
      data.input['aria-invalid'] = true;
    }

    return <div className={`form-group${hasError ? ' has-error' : ''}`}>
      <label htmlFor={`clientproduct_${data.input.name}`} className="control-label">{data.input.name}</label>
      <input {...data.input} type={data.type} step={data.step} required={data.required} placeholder={data.placeholder} id={`clientproduct_${data.input.name}`} className="form-control"/>
      {hasError && <span className="help-block" id={`clientproduct_${data.input.name}_helpBlock`}>{data.meta.error}</span>}
    </div>;
  }

 

  renderClientProductOptionFields = () => {
    if(this.props.initialValues.product.productOptions && this.props.initialValues.product.productOptions.length) {
      return this.props.initialValues.product.productOptions.map( (v,i) => {
        //in case of standings app using workaround to pass selected comps value in standings app form in order to use the name to update data in server
        if ( v.isWbs && !this.state.isAdmin ) {return null}
        if (v.type === 'standingsCompetition') {
          this.selectedCompsId = v['@id'];
          return null;
        }
        else if (v.type === 'textarea') {
          return <div key={`po_field-${i}`} className={`setting-item ${v.isWbs ? 'widefat' : ''}`}><Field fullWidth multiLine={true} rows={2} rowsMax={4} label={v.label} component={renderTextField} name={v['@id']} type={v.type} placeholder="" /></div>
        }
        else {
          return <div key={`po_field-${i}`} className="setting-item"><Field label={v.label} component={ v.type==='checkbox' ? renderCheckbox : renderTextField} name={v['@id']} type={v.type} placeholder="" /></div>
        }
      });
    }
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      this.props.initialValues && 
      <form onSubmit={handleSubmit}>
        <div className="form-divider">{literals.options[this.props.locale]}</div>
        <div className="form-settings-grid3">{this.renderClientProductOptionFields()}</div>
        {productSettings[this.props.initialValues.product['@id']].form({...this.props, 'selectedCompsId': this.selectedCompsId, 'locale': this.props.locale, 'productId': this.props.productId})}
        <button onClick={this.handleGenerateCode}type="submit" className="btn btn-primary center-padded">{literals.updatePreferences[this.props.locale]}{this.props.updateLoading ? <RichSpinner /> : ''}</button>
      </form>
    );
     
  }
}

export default reduxForm({form: 'clientproduct', enableReinitialize: false, keepDirtyOnReinitialize: false})(Form);



// WEBPACK FOOTER //
// ./src/components/clientproduct/Form.js